import type {Area, MeetingRoom} from '@lib/store';

export function isMeetingRoom(entity: Area | MeetingRoom): entity is MeetingRoom {
  if ((entity as MeetingRoom).type === 'meetingRoom') {
    return true;
  }
  return false;
}
